class DcAnnouncementRotator {
  constructor(track) {
    this.track = track;
    this.slides = [...track.children];
    this.root = track.closest('slideshow-component') || track.parentElement;
    this.previous = this.root?.querySelector('[name="previous"]');
    this.next = this.root?.querySelector('[name="next"]');
    this.delay = Number(track.dataset.speed || 5) * 1000;
    this.index = 0;
    if (this.slides.length < 2) return;

    this.previous?.addEventListener('click', () => this.goTo(this.index - 1));
    this.next?.addEventListener('click', () => this.goTo(this.index + 1));
    this.root?.addEventListener('mouseenter', this.stop);
    this.root?.addEventListener('mouseleave', this.start);
    this.root?.addEventListener('focusin', this.stop);
    this.root?.addEventListener('focusout', this.start);
    this.start();
  }

  goTo(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: 'smooth' });
  }

  start = () => {
    if (this.timer || this.track.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = window.setInterval(() => this.goTo(this.index + 1), this.delay);
  };

  stop = () => {
    window.clearInterval(this.timer);
    this.timer = undefined;
  };
}

const initializeDcAnnouncements = (scope = document) => {
  scope.querySelectorAll('.dc-announcement-bar__track[data-autoplay]').forEach((track) => {
    if (track.dataset.dcInitialized === 'true') return;
    track.dataset.dcInitialized = 'true';
    new DcAnnouncementRotator(track);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeDcAnnouncements());
document.addEventListener('shopify:section:load', (event) => initializeDcAnnouncements(event.target));
